export interface RepresentanteTranslations {
  TABLE: {
      NAME: string;
      LAST_NAME: string;
      NATIONALITY: string;
      ACTIONS: string;
      BUTTON: string;
      REPRESENTANTES: string;
      VALIDADO: string;
      ACTIVO: string;
  };
  // Aquí puedes añadir más secciones de traducción según lo necesites

  // Esta línea es la clave para que el objeto sea indexable por TypeScript
  [key: string]: any;  // Usamos 'any' para simplificar, pero podrías ser más específico si quieres
}

export const representanteTranslations: { [language: string]: RepresentanteTranslations } = {
    en: {
        TABLE: {
            NAME: "Name",
            LAST_NAME: "Surname",
            NATIONALITY: "Nationality",
            ACTIONS: "Actions",
            BUTTON: "New representative",
            REPRESENTANTES: "Representatives",
            VALIDADO: "Validated",
            ACTIVO: "Active"
        },
    },
    es: {
        TABLE: {
            NAME: "Nombre",
            LAST_NAME: "Apellidos",
            NATIONALITY: "Nacionalidad",
            ACTIONS: "Acciones",
            BUTTON: "Nuevo representante",
            REPRESENTANTES: "Representantes",
            VALIDADO: "Validado",
            ACTIVO: "Activo"
        },
    }
};

